module.exports = __webpack_public_path__ + "img/1200.2f270c66.png";